import styles from "./pa-icons.module.scss";

interface IProps {
  className?: string;
  onClick?: () => void;
  thinCross?: boolean;
}

function PACross(props: IProps) {
  const { className = "", onClick, thinCross = false } = props;

  if (thinCross) {
    return (
      <i
        className={`${styles.thin_cross} ${className}`}
        role="img"
        aria-label="Cancel"
        onClick={onClick}
      />
    );
  }
  return (
    <i
      className={`${styles.pa_icon} ${styles.close_icon} ${className} fa fa-times`}
      onClick={onClick}
    />
  );
}

export default PACross;
